import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as productivityActions } from '../../store/dux/productivity-dux';
import { actions as fieldActions } from '../../store/dux/fields-dux';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import Map from './Map';
import FieldProductivity from './FieldProductivity';
import { Section } from '../Section';
import { useCurrentUser } from '../../hooks/use-current-user';

const EMPTY = [];

export default function PotentialProductivity() {
  const dispatch = useDispatch();
  const growerId = useSelector(growerSelectors.selectedId) || '';
  const isLoading = useSelector((state) => state.productivity.isLoading);
  const fields = useSelector((state) => state.productivity.fields || EMPTY);
  const selectedFields = useSelector(
    (state) => state.fields.selectedGrowerFields || EMPTY,
  );
  const { username, userType } = useCurrentUser();
  const isAdministrator = userType === 'administrator';

  const getFieldProductivity = useCallback(
    (id) => dispatch(productivityActions.loadProductivity(id)),
    [dispatch],
  );
  const selectFields = useCallback(
    (f) => dispatch(fieldActions.setSelectedGrowerFields(f)),
    [dispatch],
  );
  const setApproval = useCallback(
    (field, isApproved) =>
      dispatch(productivityActions.setApproval(field, isApproved)),
    [dispatch],
  );

  React.useEffect(() => {
    if (growerId) dispatch(productivityActions.loadProductivity(growerId));
  }, [dispatch, growerId]);

  return (
    <Section>
      <ResizablePanel
        topPanel={<Map />}
        bottomPanel={
          <FieldProductivity
            fields={fields}
            getFieldProductivity={getFieldProductivity}
            growerId={growerId}
            isAdministrator={isAdministrator}
            isLoading={isLoading}
            selectFields={selectFields}
            selectedFields={selectedFields}
            setApproval={setApproval}
            username={username}
          />
        }
      />
    </Section>
  );
}
